var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchivedMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C4A60",
    d: "M17.033 8.926l-.374 8.44H1.341l-.374-8.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3F3F",
    d: "M.967 8.926l2.221-6.681h11.624l2.22 6.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M17.96 8.01l-.072 1.43H.112L.04 8.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACE0F9",
    d: "M.04 8.01L2.597 0h12.806l2.557 8.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.259,
    height: 1.401,
    x: 6.871,
    y: 11.877,
    fill: "#FFF",
    rx: 0.7
  })))));
}
export default SvgArchivedMessages;